<script>
import { mapStores } from "pinia";

import { useSettingsStore } from "@/stores";

import { buildCountTypeHeader, buildGenderHeader } from "./labels";
export default {
  name: "NounInflectionSchemeModal",
  props: {
    inflectionScheme: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      orderedCountTypes: ["singular", "plural"],
      labels: {
        definite: "Bestemt",
        indefinite: "Ubestemt"
      }
    };
  },
  computed: {
    ...mapStores(useSettingsStore),

    wordclassLevel() {
      return this.settingsStore.activeWordClassLevel;
    },
    scheme() {
      const tables = [];

      let isFirst = true;
      for (const [gender, scheme] of Object.entries(this.inflectionScheme)) {
        const table = {
          isFirst,
          head: [
            {
              content: buildGenderHeader(this.wordclassLevel, gender),
              primary: true
            },
            {
              content: buildCountTypeHeader(this.wordclassLevel, "singular")
            },
            {
              content: buildCountTypeHeader(this.wordclassLevel, "plural")
            }
          ],
          body: []
        };

        for (const [prefixTypeKey, rawInflections] of Object.entries(scheme)) {
          table.body.push(this.createRow(rawInflections, prefixTypeKey));
        }

        tables.push(table);
        isFirst = false;
      }

      return tables;
    }
  },
  methods: {
    createRow(data, prefixTypeKey) {
      const row = [this.labels[prefixTypeKey]];
      for (const countTypeKey of this.orderedCountTypes) {
        if (!(countTypeKey in data)) {
          row.push("-");

          continue;
        }

        row.push(this.createCell(data[countTypeKey]));
      }

      return row;
    },
    createCell(data) {
      let cell = "";
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          cell += data[i].index;
        } else {
          cell += ` / ${data[i].inflexion}`;
        }
      }

      return cell;
    }
  }
};
</script>

<template>
  <table
    v-for="(table, tableIndex) in scheme"
    :key="tableIndex"
    class="table inflection-scheme-modal__table"
    :class="{ 'mb-2': table.isFirst }"
  >
    <thead>
      <tr>
        <th
          v-for="row in table.head"
          :key="row.content"
          scope="col"
          class="inflection-scheme-modal__th"
          :class="{ 'inflection-scheme-modal__th--primary': row.primary }"
        >
          {{ table.isFirst || row.primary ? row.content : "" }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in table.body" :key="rowIndex" class="inflection-scheme-modal__tr">
        <td v-for="(content, colIndex) in row" :key="colIndex" class="inflection-scheme-modal__td">
          <span>
            {{ content }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
